import { createAction, createAsyncAction } from 'typesafe-actions'
import {
  ReadClientTypesForAssignToUserResponseDto,
  ReadClientTypesForAssignToUserRequestDto,
  ReadClientTypesRequestDto,
  ReadClientTypesResponseDto,
  GetClientTypeDetailsResponseDto,
  CreateClientTypeRequestDto,
  CreateClientTypeResponseDto,
  UpdateClientTypeRequestDto,
  UpdateClientTypeResponseDto,
  GetListOfClientTypesResponseDto,
} from '@sparling/financial-common'

export const {
  request: getListOfClientTypesRequest,
  success: getListOfClientTypesSuccess,
  failure: getListOfClientTypesFailure,
} = createAsyncAction(
  'GET_LIST_OF_CLIENT_TYPES_REQUEST',
  'GET_LIST_OF_CLIENT_TYPES_SUCCESS',
  'GET_LIST_OF_CLIENT_TYPES_FAILURE',
)<undefined, GetListOfClientTypesResponseDto[], Error>()

export const {
  request: getClientTypesForAssignToUserRequest,
  success: getClientTypesForAssignToUserSuccess,
  failure: getClientTypesForAssignToUserFailure,
} = createAsyncAction(
  'GET_CLIENT_TYPES_FOR_ASSIGN_TO_USER_REQUEST',
  'GET_CLIENT_TYPES_FOR_ASSIGN_TO_USER_SUCCESS',
  'GET_CLIENT_TYPES_FOR_ASSIGN_TO_USER_FAILURE',
)<ReadClientTypesForAssignToUserRequestDto, ReadClientTypesForAssignToUserResponseDto, Error>()

export const {
  request: getClientTypesRequest,
  success: getClientTypesSuccess,
  failure: getClientTypesFailure,
} = createAsyncAction('GET_CLIENT_TYPES_REQUEST', 'GET_CLIENT_TYPES_SUCCESS', 'GET_CLIENT_TYPES_FAILURE')<
  ReadClientTypesRequestDto,
  ReadClientTypesResponseDto,
  Error
>()

export const {
  request: getClientTypeDetailsRequest,
  success: getClientTypeDetailsSuccess,
  failure: getClientTypeDetailsFailure,
} = createAsyncAction(
  'GET_CLIENT_TYPE_DETAILS_REQUEST',
  'GET_CLIENT_TYPE_DETAILS_SUCCESS',
  'GET_CLIENT_TYPE_DETAILS_FAILURE',
)<{ id: string }, GetClientTypeDetailsResponseDto, Error>()

export const resetClientTypesFilters = createAction('RESET_CLIENT_TYPES_FILTERS')<undefined>()

export const openCreateClientTypeModal = createAction('OPEN_CREATE_CLIENT_TYPE_MODAL')<{
  open: boolean
}>()

export const openUpdateClientTypeModal = createAction('OPEN_UPDATE_CLIENT_TYPE_MODAL')<{
  open: boolean
  id: string | null
  currentName: string | null
}>()

export const openViewClientTypeModal = createAction('OPEN_VIEW_CLIENT_TYPE_MODAL')<{
  open: boolean
}>()

export const {
  request: createClientTypeRequest,
  success: createClientTypeSuccess,
  failure: createClientTypeFailure,
} = createAsyncAction('CREATE_CLIENT_TYPE_REQUEST', 'CREATE_CLIENT_TYPE_SUCCESS', 'CREATE_CLIENT_TYPE_FAILURE')<
  CreateClientTypeRequestDto,
  CreateClientTypeResponseDto,
  Error
>()

export const {
  request: updateClientTypeRequest,
  success: updateClientTypeSuccess,
  failure: updateClientTypeFailure,
} = createAsyncAction('UPDATE_CLIENT_TYPE_REQUEST', 'UPDATE_CLIENT_TYPE_SUCCESS', 'UPDATE_CLIENT_TYPE_FAILURE')<
  { id: string } & UpdateClientTypeRequestDto,
  UpdateClientTypeResponseDto,
  Error
>()
